// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__JJVqg","arrow_icon":"styles_arrow_icon__3AWR5"};